/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

angular.module('aviApp').directive('performanceChartTitle', function() {
    return {
        restrict: 'A',
        templateUrl: 'src/views/components/performance-chart-title.html',
    };
});
